export type ErrorType = "not_found";

export class ApiError extends Error {
  constructor(public type: ErrorType) {
    super(`Documaster ApiError: ${type}`);
  }
}
